import React from "react";

import {
  ContractClassification,
  EContractType,
  ESenderRole,
  IContractActionsResponseData,
  IContractDetailsResponseData,
} from "../../setup/api/services/contract/models";
import {
  actionTypes,
  GetContractActivitiesType,
  GetContractActionType,
  setContractTypeAction,
  setSenderRoleAction,
} from "./contract.actions";

export interface ContractState {
  contract?: IContractDetailsResponseData;
  contractActivities?: IContractActionsResponseData[];
  loading: boolean;
  contractClassification: ContractClassification;
  contractType?: EContractType;
  senderRole: ESenderRole;
}

export const CONTRACT_INITIAL_STATE = {
  contract: undefined,
  contractActivities: undefined,
  loading: false,
  contractClassification: ContractClassification.BASIC,
  contractType: EContractType.QUICK_TRANSACTION,
} as ContractState;

export const contractReducer: React.Reducer<
  ContractState,
  | GetContractActionType
  | GetContractActivitiesType
  | setContractTypeAction
  | setSenderRoleAction
> = (prevState, action): ContractState => {
  switch (action.type) {
    case actionTypes.GET_CONTRACT:
      return {
        ...prevState,
        ...action.payload,
      };

    case actionTypes.SET_CONTRACT_CLASSIFICATION:
      return {
        ...prevState,
        ...action.payload,
      };
    case actionTypes.SET_SENDER_ROLE:
      return {
        ...prevState,
        ...action.payload,
      };
    case actionTypes.GET_CONTRACT_ACTIVITIES:
      return {
        ...prevState,
        ...action.payload,
      };
    default:
      return prevState;
  }
};
